module.exports = __webpack_public_path__ + "src/assets/marketing/splashScreenIcon.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/marketing/splashScreenIcon.png
// module id = ./src/assets/marketing/splashScreenIcon.png
// module chunks = 0